module.exports = __webpack_public_path__ + "img/icon_j6.2fa076c.png";